import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Brand } from "@/components/Brand";
import { useAuth } from "@/context/AuthContext";
import { LogOut, DoorOpen, Landmark, Users, CalendarClock } from "lucide-react";
import RoomsTab from "@/components/console/RoomsTab";
import CourtTab from "@/components/console/CourtTab";
import CollaboratorsTab from "@/components/console/CollaboratorsTab";
import AppointmentsTab from "@/components/console/AppointmentsTab";

export default function Console() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("rooms");

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  const TABS = [
    { id: "rooms", label: "Stanze & Turni", icon: DoorOpen },
    { id: "court", label: "Agenda Udienze", icon: Landmark },
    { id: "collaborators", label: "Collaboratori", icon: Users },
    { id: "appointments", label: "Appuntamenti", icon: CalendarClock },
  ];

  return (
    <div className="min-h-screen bg-[#F4EFE4] grain-overlay">
      <header className="sticky top-0 z-40 backdrop-blur-md bg-[#F4EFE4]/90 border-b border-amber-500/15">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-3 flex items-center justify-between">
          <Brand />
          <div className="flex items-center gap-3">
            <div className="hidden sm:flex items-center gap-3 mr-2">
              {user?.picture && <img src={user.picture} alt="" className="w-8 h-8 rounded-full border border-amber-500/40" />}
              <div className="text-right leading-tight">
                <div className="text-sm text-stone-900">{user?.name}</div>
                <div className="text-[10px] uppercase tracking-wider text-amber-600/70">{user?.role === "admin" ? "Titolare" : "Collaboratore"}</div>
              </div>
            </div>
            <Button onClick={handleLogout} data-testid="logout-btn" variant="ghost" size="sm"
              className="text-stone-500 hover:text-red-600 hover:bg-red-500/10">
              <LogOut className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 md:px-8 py-8">
        <div className="mb-8">
          <h1 className="font-serif text-3xl md:text-4xl text-stone-900">Console Operativa</h1>
          <p className="text-stone-500 text-sm mt-1">Gestione turni stanze, agenda tribunale, collaboratori e appuntamenti.</p>
        </div>

        <Tabs value={tab} onValueChange={setTab}>
          <TabsList className="bg-[#FFFFFF] border border-amber-500/15 p-1 h-auto flex-wrap gap-1 mb-8">
            {TABS.map((t) => (
              <TabsTrigger key={t.id} value={t.id} data-testid={`console-tab-${t.id}`}
                className="data-[state=active]:bg-amber-500 data-[state=active]:text-[#221C12] text-stone-600 rounded-lg px-4 py-2.5">
                <t.icon className="w-4 h-4 mr-2" /> {t.label}
              </TabsTrigger>
            ))}
          </TabsList>

          <TabsContent value="rooms"><RoomsTab /></TabsContent>
          <TabsContent value="court"><CourtTab /></TabsContent>
          <TabsContent value="collaborators"><CollaboratorsTab /></TabsContent>
          <TabsContent value="appointments"><AppointmentsTab /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
